export const iconButtons = `
  active:opacity-100
  bg-tint-less
  rounded-full
  cursor-pointer
  hover:opacity-90
  hover:text-accent
  inline-flex
  items-center
  lowercase
  no-underline
  opacity-40
  px-2
  py-1
  text-accent
`
